export const Typography = {
  'font-family': "'InterVariable'",
  'font-weight': {
    regular: 450,
    semibold: 650,
  },
  'letter-spacing': {
    '300': 0,
    '400': '-0.08',
    '500': '-0.18',
    '600': '-0.25',
    '700': '-0.34',
    '900': '-0.46',
    '1100': '-0.56',
    '1500': '-0.79',
    '1700': '-0.88',
    '2100': '-1.06',
    '500-caps': '0.96',
    '400-caps': '0.82',
    '300-caps': '0.66',
  },
  'Body L': {
    'line-height': 24,
    'compact-line-height': 22,
    'font-size': 18,
  },
  'Body M': {
    'line-height': 24,
    'compact-line-height': 20,
    'font-size': 16,
  },
  'Body S': {
    'line-height': 20,
    'compact-line-height': 18,
    'font-size': 14,
  },
  'Body XS': {
    'line-height': 16,
    'compact-line-height': 15,
    'font-size': 12,
  },
  'CAPS L': {
    'line-height': 20,
    'font-size': 16,
  },
  'CAPS M': {
    'line-height': 18,
    'font-size': 14,
  },
  'CAPS S': {
    'line-height': 15,
    'font-size': 11,
  },
  'Heading L': {
    'line-height': 40,
    'font-size': 32,
  },
  'Heading M': {
    'line-height': 36,
    'font-size': 28,
  },
  'Heading S': {
    'line-height': 30,
    'font-size': 24,
  },
  'Heading XS': {
    'line-height': 25,
    'font-size': 20,
  },
  iOS: 'Large',
};
